<template>
  <div>
    <!-- Page Content -->
    <div class="content">
      <!-- Full Table -->
      <base-block rounded title="Daily Challenge">
        <div class="text-right" v-if="!dailyPatterns.length >= 1 && $store.getters.userDetails.includes('CAN_ADD_DAILY_CHALLENGE')">
          <b-button
            variant="success"
            href="/#/backend/forms/add-daily-challenge"
            >+ Add Pattern</b-button
          >
        </div>
        <br />
        <div class="d-flex justify-content-end mb-2">
          <input
            class="form-control"
            type="text"
            placeholder="Search..."
            aria-label="Search"
            style="width: 300px"
          />
        </div>

        <label>PATTERN</label>
        <b-table-simple responsive bordered striped table-class="table-vcenter">
          <b-thead>
            <b-tr>
              <b-th class="text-center">S.NO</b-th>
              <b-th class="text-center">Name</b-th>
              <b-th class="text-center">Duration (mins)</b-th>
              <b-th class="text-center">Number Of Questions</b-th>
              <b-th class="text-center" v-if="$store.getters.userDetails.includes('CAN_STATUS_DAILY_CHALLENGE')">Status</b-th>
              <b-th class="text-center" v-if="$store.getters.userDetails.includes('CAN_DELETE_DAILY_CHALLENGE') ">Action</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(dailyPattern, index) in dailyPatterns" :key="index">
              <b-td class="text-center">
                {{ index + 1 }}
              </b-td>
              <b-td class="text-center">
                {{ dailyPattern.name }}
              </b-td>
              <b-td class="text-center">
                {{ dailyPattern.tests.duration }}
              </b-td>
              <b-td class="text-center">
                {{ dailyPattern.tests.no_of_questions }}
              </b-td>
               <b-td class="text-center" v-if="$store.getters.userDetails.includes('CAN_STATUS_DAILY_CHALLENGE')">
                <b-button
                  :class="{ 'btn-danger': !dailyPattern.status }"
                  size="sm"
                  :variant="buttonVariant1"
                  @click="toggleStatuspattern(dailyPattern.id, index, dailyPattern.status)"
                >
                  {{ dailyPattern.status ? "Active" : "Deactive" }}
                </b-button>
              </b-td>
              <b-td class="text-center" v-if="$store.getters.userDetails.includes('CAN_DELETE_DAILY_CHALLENGE')">
                  <b-btn-group>
                 <b-button
                  size="sm"
                  variant="alt-primary"
                  @click="deleteDailyChallenge(dailyPattern.id)"
                >
                  <i class="fa fa-fw fa-times"></i>
                </b-button>
                  </b-btn-group>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
         </base-block>
         <base-block rounded title=" Daily Challenges">
       
         <!-- Daily challenges -->
         <b-table-simple responsive bordered striped table-class="table-vcenter">
          <b-thead>
            <b-tr>
              <b-th class="text-center">S.NO</b-th>
              <b-th class="text-center">Name</b-th>
              <b-th class="text-center">Duration (mins)</b-th>
              <b-th class="text-center">Number Of Questions</b-th>
             <!-- <b-th class="text-center">Negative Mark</b-th>
              <b-th class="text-center">Each Question Mark</b-th>
              <b-th class="text-center">result Status</b-th>
              <b-th class="text-center">Start Date Time</b-th>
              <b-th class="text-center">End Date Time</b-th>-->
              <b-th class="text-center" v-if="$store.getters.userDetails.includes('CAN_STATUS_DAILY_CHALLENGE')">Status</b-th>
              <b-th class="text-center" v-if="$store.getters.userDetails.includes('CAN_SEE_DAILY_CHALLENGE')">Action</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(dailyTest, index) in dailyTests" :key="index">
              <b-td class="text-center">
                {{ index + 1 }}
              </b-td>
              <b-td class="text-center">
                {{ dailyTest.name }}
              </b-td>
              <b-td class="text-center">
                {{ dailyTest.tests.duration }}
              </b-td>
              <b-td class="text-center">
                {{ dailyTest.tests.no_of_questions }}
              </b-td>
             <!-- <b-td class="text-center">
                {{ dailyTest.tests.negative_mark }}
              </b-td>
              <b-td class="text-center">
                {{ dailyTest.tests.each_question_mark }}
              </b-td>
              <b-td class="text-center">
                {{dailyTest.tests.result_status }}
              </b-td>
              <b-td class="text-center">
                {{ dailyTest.tests.start_date_time }}
              </b-td>
              <b-td class="text-center">
                {{ dailyTest.tests.end_date_time }}
              </b-td>-->
               <b-td class="text-center" v-if="$store.getters.userDetails.includes('CAN_STATUS_DAILY_CHALLENGE')">
                <b-button
                  :class="{ 'btn-danger': !dailyTest.status }"
                  size="sm"
                  :variant="buttonVariant"
                  @click="toggleStatus(dailyTest.id, index, dailyTest.status)"
                >
                  {{ dailyTest.status ? "Active" : "Deactive" }}
                </b-button>
              </b-td>
              <b-td class="text-center"  v-if="$store.getters.userDetails.includes('CAN_SEE_DAILY_CHALLENGE')">
                  <b-btn-group>
                  <router-link
                    :to="{
                      name: 'Daily Test Details',
                      params: {id: dailyTest.id },
                    }"
                  >
                <b-button
                  size="sm"
                  variant="alt-primary"
                >
                  <i class="fa fa-eye"></i>
                </b-button>
                </router-link>
                 <!--<b-button
                  size="sm"
                  variant="alt-primary"
                  @click="deleteDailyChallenge(dailyTest.id)"
                >
                  <i class="fa fa-fw fa-times"></i>
                </b-button>-->
                  </b-btn-group>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>

      </base-block>
      <!-- END Full Table -->
    </div>
    <!-- END Page Content -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      dailyTests: [],
      dailyPatterns:[],
      buttonVariant: "success",
      buttonVariant1: "success"
    };
  },
  mounted() {
    this.getDailyPattern();
    this.getDailyChallenge();
  },
  methods: {
    async toggleStatuspattern(id, index, status) {
      await axios
        .get(`${this.$store.getters.baseUrl}/daily-challenge/status/${id}`, {
          headers: { Authorization: `Bearer ${this.$store.getters.token}` },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            console.log("came");
            this.dailyPatterns[index].status = status == 1 ? 0 : 1;
            this.$swal("Success", "Daily test pattern status changed successfully", "success");
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async toggleStatus(id, index, status) {
      await axios
        .get(`${this.$store.getters.baseUrl}/daily-challenge/status/${id}`, {
          headers: { Authorization: `Bearer ${this.$store.getters.token}` },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.dailyTests[index].status = status == 1 ? 0 : 1;
            this.$swal("Success", "Daily test challenge status changed successfully", "success");
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async deleteDailyChallenge(id) {
      await axios
        .get(`${this.$store.getters.baseUrl}/daily-challenge/delete/${id}`, {
          headers: { Authorization: `Bearer ${this.$store.getters.token}` },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.$swal(
              "Success",
              "Daily challenge test deleted successfully",
              "success"
            );
            this.getDailyChallenge();
            this.getDailyPattern();
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async getDailyPattern() {
      await axios
        .get(`${this.$store.getters.baseUrl}/daily-challenge/pattern-lists`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.dailyPatterns = response.data.daily_test_pattern;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
     async getDailyChallenge() {
      await axios
        .get(`${this.$store.getters.baseUrl}/daily-challenges`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.dailyTests = response.data.daily_tests;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>
